/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Tabs, Tab } from '@mui/material';
import FolderSummaryComponentBeta from './summary/components/FolderSummaryComponentBeta';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import Timeline from '@mui/icons-material/Timeline';
import { loadFolderSummaryBeta } from './actionCreatorsBeta';
import { loadDocumentTasks } from 'features/tasks/actionCreators';
import DocumentTasksContainer from 'features/offer/edit/sidebar/components/summary/DocumentTasksContainer';
import Assignment from '@mui/icons-material/Assignment';

export const FolderSidebarContainerBeta = ({ t, documentId, siteId }) => {
  const [tabValue, setTabValue] = useState(0);
  const key = `${documentId}-${siteId}`;
  const folderSummary = useSelector(state => state.currentFolder.sidebarData.summary, shallowEqual);
  const documentTasks = useSelector(state => state.tasksData[key]?.tasksList, shallowEqual);
  let firstUpdate = false;
  const dispatch = useDispatch();

  const tasksTab = <DocumentTasksContainer documentTasks={documentTasks} documentId={documentId} siteId={siteId} isFolder={true} />;

  useEffect(() => {
    if (Number.isInteger(documentId)) {
      dispatch(loadFolderSummaryBeta(documentId, siteId));
      dispatch(loadDocumentTasks(documentId, siteId));
    }
    firstUpdate = true; // eslint-disable-line react-hooks/exhaustive-deps
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        dispatch(loadFolderSummaryBeta(documentId, siteId));
      }
    }
  }, [documentId, siteId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!firstUpdate) {
      if (Number.isInteger(documentId)) {
        dispatch(loadFolderSummaryBeta(documentId, siteId));
      }
    }
  }, [folderSummary]); // eslint-disable-line react-hooks/exhaustive-deps

  const summaryTab = (
    <React.Fragment>
      <FolderSummaryComponentBeta folderSummary={folderSummary} />
    </React.Fragment>
  );

  const handleChange = (_, value) => {
    setTabValue(value);
  };

  return (
    <React.Fragment>
      <Tabs value={tabValue} onChange={handleChange} variant='fullWidth' indicatorColor='secondary' textColor='secondary'>
        <Tab icon={<Timeline />} label={t('Folder.SummaryTabTitle')} />
        {documentTasks && documentTasks.length > 0 && <Tab icon={<Assignment />} label={t('Tasks.TabTitle')} />}
      </Tabs>
      {tabValue === 0 && summaryTab}
      {tabValue === 1 && tasksTab}
    </React.Fragment>
  );
};

FolderSidebarContainerBeta.propTypes = {
  t: PropTypes.func.isRequired,
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  documentTasks: PropTypes.array.isRequired
};

export default withTranslation()(FolderSidebarContainerBeta);
